/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from '../../utils/styled'

interface InputProps {
  children?: React.ReactNode
  name: string
  label: string | React.JSX.Element
  type?: string
  placeholder?: string
  value?: any
  onChange: (e: string) => void
}

interface InputContainerProps {
  isCheckbox: boolean
}

const InputContainer = styled.div<InputContainerProps>`
  display: flex;
  flex-direction: ${({ isCheckbox }) => (isCheckbox ? 'row-reverse' : 'column')};
  justify-content: ${({ isCheckbox }) => (isCheckbox ? 'start' : 'initial')};
  align-items: ${({ isCheckbox }) => (isCheckbox ? 'center' : 'initial')};
  padding-bottom: 1rem;
`

const ChechboxLabel = styled.label`
  font-size: ${props => props.theme.fontSizes.body1};
  color: ${props => props.theme.colors.body};
  font-weight: 500;
  margin-left: 0.5rem;
`

const InputLabel = styled.label`
  font-size: ${props => props.theme.fontSizes.body2};
  color: ${props => props.theme.colors.body};
  font-weight: 500;
  margin-bottom: 0.25rem;
`

const InputSelect = styled.select`
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid ${props => props.theme.colors.borders};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`

const InputField = styled.input`
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid ${props => props.theme.colors.borders};
`

const Input: React.FC<InputProps> = ({
  name,
  label,
  placeholder = typeof label === 'string' ? label : '',
  type = 'text',
  value,
  onChange,
  children
}) => {
  const isCheckbox = type === 'checkbox'

  return (
    <InputContainer isCheckbox={isCheckbox}>
      {isCheckbox ? <ChechboxLabel htmlFor={name}>{label}</ChechboxLabel> : <InputLabel htmlFor={name}>{label}</InputLabel>}
      {type === 'select' ? (
        <InputSelect id={name} name={name} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)}>
          {children}
        </InputSelect>
      ) : (
        <InputField
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          onChange={e => onChange(e.target.value)}
          value={value}
          checked={type === 'checkbox' && value === true}
        />
      )}
    </InputContainer>
  )
}

export default Input
